import { isEqual } from 'lodash';

import type { UIFlagFilter } from '../types';

import { defaultFlagFilter } from './defaultFlagFilter';

export function isDefaultFlagFilterValue<K extends keyof UIFlagFilter>(name: K, value: UIFlagFilter[K]) {
  if (value === undefined) {
    return false;
  }

  return isEqual(value, defaultFlagFilter[name]);
}
